<template>
  <v-chart
    class="chart"
    :option="option"
    autoresize/>
</template>

<script>
import VChart from 'vue-echarts'

export default {
  name: "ChartAffiliationWaterfall",
  components: {
    VChart,
  },
  props: {
    affiliation: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      option: {
        title: {
          text: "Afiliaciones",
          left: "center"
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            const tar = params[1];
            return tar.name + '<br/>' + tar.seriesName + ' : ' + tar.value;
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          splitLine: {show: false},
          data: [
            "Solicitudes",
            "Canceladas por ciudadano",
            "Rechazadas por partido político",
            "Aprobadas por partido político"
          ]
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: 'Placeholder',
            type: 'bar',
            stack: 'Total',
            itemStyle: {
              borderColor: 'transparent',
              color: 'transparent'
            },
            emphasis: {
              itemStyle: {
                borderColor: 'transparent',
                color: 'transparent'
              }
            },
            data: this.getData()
          },
          {
            name: 'Solicitud',
            type: 'bar',
            stack: 'Total',
            label: {
              show: true,
              position: 'inside'
            },
            data: [
              parseInt(this.affiliation.affiliation),
              parseInt(this.affiliation.cancel),
              parseInt(this.affiliation.refuse),
              parseInt(this.affiliation.aproved),
            ]
          }
        ]
      }
    };
  },
  methods: {
    getData() {
      const cancel = parseInt(this.affiliation.affiliation) - parseInt(this.affiliation.cancel)
      const refuse = cancel - parseInt(this.affiliation.refuse)
      const aproved = refuse - parseInt(this.affiliation.aproved)

      return [
        0,
        cancel > 0 ? cancel : 0,
        refuse > 0 ? refuse : 0,
        aproved > 0 ? aproved : 0
      ]
    }
  }
}
</script>

<style scoped>
.chart {
  height: 550px;
}
</style>
